import { Stack, Typography } from "@mui/material"
import { FieldTypography } from "./field-typography"

export function FieldInfo({ description, allowMultiple = false, allowFixedValue = false, required = false }) {
    return (
        <Stack spacing={0.5}>
            <Typography variant="body2" align="center">
                {description}
            </Typography>
            {allowMultiple && <FieldTypography text="Multiple can be selected" />}
            {allowFixedValue && <FieldTypography text="A fixed value can be typed to apply to all columns" />}
            {required && <FieldTypography text="Mandatory*" color="error.main" />}
        </Stack>
    )
}
